module.exports = __webpack_public_path__ + "static/media/1022745.cbaa7be2.jpg";